export class PropertyName {
    public static INPUT_APPRESULTS = "Input.AppResults";
    public static INPUT_BIOSAMPLES = "Input.BioSamples";
    public static INPUT_PROJECTS = "Input.Projects";
    public static INPUT_RUNS = "Input.Runs";
    public static INPUT_SAMPLES = "Input.Samples";
    public static OUTPUT_APPRESULTS = "Output.AppResults";
    public static OUTPUT_DATASETS = "Output.Datasets";
    public static OUTPUT_PROJECTS = "Output.Projects";
    public static OUTPUT_SAMPLES = "Output.Samples";
    public static OUTPUT_SAMPLES_ITEMS = 'Output.Samples/Items';
    public static LOG_TAIL = "Logs.Tail";
    public static SUMMARY_REPORT_FILE = "BaseSpace.SummaryReportFile";
    public static DATASET_REPORT_FILE = "BaseSpace.ReportFile";
    public static DATASET_METRICS_FILE = "BaseSpace.MetricsFile";
    public static IMPORT_TYPE_PROPERTY_NAME = 'import.type';
}
